<template>
    <div>
        <span  v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <div style="text-align:left;padding:20px;background-color:#ECEFF1;">
               <v-table style="background-color:#ECEFF1;">
                    <tr>

                        <td>
                           <h4 class="text-h5">
                                {{ k }}
                           </h4>
                        </td>
                   </tr>
               </v-table>
            </div>
            <v-tabs
                bg-color="#ECEFF1"
                color="#01579B"
                align-tabs="left"
            >
                <v-tab>
                    <router-link style="text-decoration:none;"
                        :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-fusion-details/${k}`
                             }"
                    ><v-btn id="variant-nav-bar-summary" elevation="3" style="padding:0;">
                        <span
                            v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='summary', 'var-nav-bar-btn-default': this.varPage != 'summary' }">
                            Fusion
                        </span>
                     </v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link style="text-decoration:none;"
                        :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-fusion-details/${k}/treatments`,
                         }"
                    >
                    <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                         <span
                                 v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='treatments', 'var-nav-bar-btn-default': this.varPage != 'treatments' }"
                         >
                            Treatments
                         </span>
                     </v-btn>
                    </router-link>
                </v-tab>
            </v-tabs>
        </span>
    </div>
</template>
<script>
</script>
<style>
</style>
